import { Navigate } from 'react-router-dom';
import { useUserStore } from '@/stores/userStore';
import { getFirstAuthorizedRoute } from './utils';
import { getHasPermissionRoutes } from './getHasPermissionRoutes';

export type DynamicRedirectProps = {
  /**
   * 首先尝试跳转的路由，如果没权限再查找第一个有权限的路由进行跳转
   * - 注意只能传根路由的子路由路径，即：/404 /login与根路由同级的路由路径无效
   */
  targetRoute?: {
    path: string;
    permCode: string;
  };
};

/**
 * 动态重定向组件
 * 根据用户权限重定向到第一个有权限的页面
 */
export function DynamicRedirect({ targetRoute }: DynamicRedirectProps) {
  const { userInfo } = useUserStore();
  const permissionCodes = userInfo?.permissionCodes || [];

  // 获取用户有权限的路由
  const authorizedRoutes = getHasPermissionRoutes(permissionCodes);

  // 从根路由的 children 开始查找第一个有权限的路由
  const rootRoute = authorizedRoutes.find((route) => route.path === '/');
  if (targetRoute && permissionCodes.includes(targetRoute.permCode)) {
    return <Navigate to={targetRoute.path} replace />;
  }
  const firstRoute = rootRoute?.children ? getFirstAuthorizedRoute(rootRoute.children) : null;
  if (targetRoute) {
    console.warn(
      `找不到${targetRoute.path}对应的权限码或者${targetRoute.path}没有权限，返回第一个有权限的路由:${firstRoute}`
    );
  }
  // 如果找到有权限的路由，重定向到该路由，否则重定向到登录页面
  return <Navigate to={firstRoute || '/login'} replace />;
}
